import axios from 'axios'
import { cca_config } from '../../plugins/cca-config'
import guardSession from '@/api/session-guard'
import store from '@/store'

export default () => {
    const auth_info = store.getters['authInfo']
    let token = ''
    if (auth_info) {
        token = (Object.prototype.hasOwnProperty.call(auth_info, 'access_token'))?auth_info.access_token:''
    }

    const instance = axios.create({
        baseURL: cca_config.C_URL+cca_config.C_URL_STOCK_API,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })

    // Add a response interceptor
    instance.interceptors.response.use(
        response => response, // Return response if successful
        async error => {
            await guardSession(error, token)
            return Promise.reject(error);
        }
    );
    return instance
}
